'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_CLICK_ACTION = exports.DID_YOU_MEAN_RESULT_ACTION = exports.RESULT_ACTION = exports.BROADEN_SEARCH_ACTION = exports.DID_YOU_MEAN_CLICK_EVENT = exports.DID_YOU_MEAN_IMPRESSION_EVENT = exports.SEARCH_RESULTS_EVENT = exports.EMPTY_SEARCH_RESULTS_EVENT = exports.BROADEN_SEARCH_EVENT = exports.EMPTY_SEARCH_GTM_CATEGORY = exports.SEARCH_GTM_CATEGORY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeBroadenSearchEvent = composeBroadenSearchEvent;
exports.composeEmptySearchResultsEvent = composeEmptySearchResultsEvent;
exports.composeSearchResultsEvent = composeSearchResultsEvent;
exports.composeDidYouMeanImpressionEvent = composeDidYouMeanImpressionEvent;
exports.composeDidYouMeanClickEvent = composeDidYouMeanClickEvent;

var _compose = require('./compose');

var SEARCH_GTM_CATEGORY = exports.SEARCH_GTM_CATEGORY = 'v2-search';
var EMPTY_SEARCH_GTM_CATEGORY = exports.EMPTY_SEARCH_GTM_CATEGORY = 'v2-search-empty';

var BROADEN_SEARCH_EVENT = exports.BROADEN_SEARCH_EVENT = 'bc.broadenSearch';
var EMPTY_SEARCH_RESULTS_EVENT = exports.EMPTY_SEARCH_RESULTS_EVENT = 'bc.emptySearchResult';
var SEARCH_RESULTS_EVENT = exports.SEARCH_RESULTS_EVENT = 'bc.searchResult';
var DID_YOU_MEAN_IMPRESSION_EVENT = exports.DID_YOU_MEAN_IMPRESSION_EVENT = 'bc.dymSearchResultImpression';
var DID_YOU_MEAN_CLICK_EVENT = exports.DID_YOU_MEAN_CLICK_EVENT = 'bc.dymSearchResultClick';

var BROADEN_SEARCH_ACTION = exports.BROADEN_SEARCH_ACTION = 'v2-broaden';
var RESULT_ACTION = exports.RESULT_ACTION = 'v2-result';
var DID_YOU_MEAN_RESULT_ACTION = exports.DID_YOU_MEAN_RESULT_ACTION = 'v2-result-did-you-mean';
var LINK_CLICK_ACTION = exports.LINK_CLICK_ACTION = 'v2-link-click';

function composeSearchEvent(eventCategory, eventName, eventValue, eventAction, eventLabel) {
  var payload = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  return (0, _compose.composeEvent)(eventName, _extends({
    gtmValue: eventValue,
    gtmAction: eventAction,
    gtmCategory: eventCategory,
    gtmLabel: eventLabel
  }, payload));
}

function composeBroadenSearchEvent(_ref) {
  var query = _ref.query,
      searchType = _ref.searchType;

  return (0, _compose.composeAnalytics)([composeSearchEvent(SEARCH_GTM_CATEGORY, BROADEN_SEARCH_EVENT, 1, BROADEN_SEARCH_ACTION, query, { searchType: searchType })]);
}

function composeEmptySearchResultsEvent(_ref2) {
  var query = _ref2.query,
      searchType = _ref2.searchType;

  return (0, _compose.composeAnalytics)([composeSearchEvent(EMPTY_SEARCH_GTM_CATEGORY, EMPTY_SEARCH_RESULTS_EVENT, 1, RESULT_ACTION, query, { searchType: searchType })]);
}

function composeSearchResultsEvent(_ref3) {
  var query = _ref3.query,
      searchType = _ref3.searchType;

  return (0, _compose.composeAnalytics)([composeSearchEvent(SEARCH_GTM_CATEGORY, SEARCH_RESULTS_EVENT, 1, RESULT_ACTION, query, { searchType: searchType })]);
}

function composeDidYouMeanImpressionEvent(_ref4) {
  var query = _ref4.query,
      suggestion = _ref4.suggestion;

  return (0, _compose.composeAnalytics)([composeSearchEvent(EMPTY_SEARCH_GTM_CATEGORY, DID_YOU_MEAN_IMPRESSION_EVENT, 1, DID_YOU_MEAN_RESULT_ACTION, suggestion + ' | ' + query)]);
}

function composeDidYouMeanClickEvent(_ref5) {
  var query = _ref5.query,
      suggestion = _ref5.suggestion;

  return (0, _compose.composeAnalytics)([composeSearchEvent(EMPTY_SEARCH_GTM_CATEGORY, DID_YOU_MEAN_CLICK_EVENT, 1, LINK_CLICK_ACTION, suggestion + ' | ' + query)]);
}

exports.default = {
  SEARCH_GTM_CATEGORY: SEARCH_GTM_CATEGORY,
  EMPTY_SEARCH_GTM_CATEGORY: EMPTY_SEARCH_GTM_CATEGORY,
  BROADEN_SEARCH_EVENT: BROADEN_SEARCH_EVENT,
  EMPTY_SEARCH_RESULTS_EVENT: EMPTY_SEARCH_RESULTS_EVENT,
  SEARCH_RESULTS_EVENT: SEARCH_RESULTS_EVENT,
  DID_YOU_MEAN_IMPRESSION_EVENT: DID_YOU_MEAN_IMPRESSION_EVENT,
  DID_YOU_MEAN_CLICK_EVENT: DID_YOU_MEAN_CLICK_EVENT,
  BROADEN_SEARCH_ACTION: BROADEN_SEARCH_ACTION,
  RESULT_ACTION: RESULT_ACTION,
  DID_YOU_MEAN_RESULT_ACTION: DID_YOU_MEAN_RESULT_ACTION,
  LINK_CLICK_ACTION: LINK_CLICK_ACTION,
  composeBroadenSearchEvent: composeBroadenSearchEvent,
  composeEmptySearchResultsEvent: composeEmptySearchResultsEvent,
  composeSearchResultsEvent: composeSearchResultsEvent,
  composeDidYouMeanImpressionEvent: composeDidYouMeanImpressionEvent,
  composeDidYouMeanClickEvent: composeDidYouMeanClickEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/searchEventComposer.js
// module id = 997
// module chunks = 1